import { render } from "./LoadBalancer.vue?vue&type=template&id=33c12dfe"
import script from "./LoadBalancer.vue?vue&type=script&lang=js"
export * from "./LoadBalancer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__